import type { Features } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: Features = {};

type ToggleFeaturePayload = {
  feature: string;
  showFeature: boolean;
};

const store = createSlice({
  name: 'features',
  initialState,
  reducers: {
    toggleFeature: (state, action: PayloadAction<ToggleFeaturePayload>) => {
      const { feature, showFeature } = action.payload;
      state[feature.toUpperCase()] = showFeature;
    },
  },
});

export const { toggleFeature } = store.actions;

export default store;
